import React, { useState, useEffect } from 'react';

const FAQ = ({ title = "Frequently Asked Questions" }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const revealOnScroll = () => {
      const elements = document.querySelectorAll('.fade-in');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 100;
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('visible');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How do I add Raix to my Discord server?",
      answer: "Click the 'Add to Discord' button, select your server from the dropdown menu, and authorize the required permissions. Raix will be added to your server instantly!"
    },
    {
      question: "Is Raix free to use?",
      answer: "Yes! Raix is completely free to use with all features available. We believe in providing quality tools to all Discord communities without any cost."
    },
    {
      question: "What permissions does Raix need?",
      answer: "Raix requires standard moderation permissions including managing messages, kicking/banning members, managing roles, and reading message history. These permissions ensure all features work properly."
    },
    {
      question: "How do I configure Raix for my server?",
      answer: "Use the /config command to access the configuration panel. You can customize prefixes, enable/disable features, set up auto-moderation, and configure welcome messages."
    },
    {
      question: "Does Raix support slash commands?",
      answer: "Yes! Raix fully supports Discord's slash commands, making it easy to use and discover all available features directly from Discord's interface."
    },
    {
      question: "How can I get help or report a bug?",
      answer: "Join our support server using the link in the footer, or email us at factsonly9667@gmail.com. Our team is always ready to help you with any issues or questions."
    },
    {
      question: "Can I customize Raix's responses?",
      answer: "Absolutely! Raix offers extensive customization options. You can customize command responses, welcome messages, auto-mod settings, and much more to match your server's personality."
    },
    {
      question: "What kind of moderation features does Raix offer?",
      answer: "Raix includes kick, ban, warn, mute, auto-moderation, message filtering, raid protection, and detailed moderation logs to keep your server safe and organized."
    }
  ];

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="section-title fade-in">
          <h2>{title}</h2>
          <p>Find answers to common questions</p>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              className={`faq-item fade-in ${activeIndex === index ? 'active' : ''}`} 
              key={index}
            >
              <div 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
              >
                <h3>{faq.question}</h3>
                <span className="faq-toggle">{activeIndex === index ? '−' : '+'}</span>
              </div>
              <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
